<template>
  <div class="main-comment-task">
    <div class="d-flex input-chat">
      <v-textarea
        v-model="contentComment"
        row-height="20"
        rows="1"
        variant="filled"
        class="custom-input-task textarea-type comment"
        placeholder="Viết bình luận"
        auto-grow
        :counter="250"
        :maxlength="250"
      ></v-textarea>
      <div class="ml-2 d-flex">
        <v-btn
          small
          class="btn-send m-auto"
          :style="{ opacity: !contentComment ? '0.6' : '1' }"
          @click="sendComment()"
        >
          Gửi
        </v-btn>
      </div>
    </div>
    <div
      class="mt-2 list-comment"
      v-if="listComment && listComment.length"
      id="style-2"
    >
      <div
        class="d-flex my-2"
        v-for="(comment, index) in listCommentClone"
        :key="'cmt' + index"
      >
        <div class="d-flex w-full">
          <div class="ml-2">
            <v-avatar size="30" :color="comment.color">
              <span style="color: #fff; font-weight: 700">{{
                getTwoLastWordInName(comment.userCreated.fullName)
              }}</span>
            </v-avatar>
          </div>
          <div class="ml-2 w-full">
            <div class="d-flex justify-space-between">
              <div class="font-weight-bold">
                {{ comment.userCreated.fullName }}
              </div>
              <div class="ml-2">{{ formatDateTime(comment.created_at) }}</div>
            </div>
            <div class="ml-2">{{ comment.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';

export default {
  props: {
    listComment: {
      type: Array,
      default: () => [],
    },
    isOpenTaskCSDK: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentComment: '',
      listColor: [
        '#FAA04D',
        '#75D5EA',
        '#D8719C',
        '#BBCD74',
        '#7FB97E',
        '#5BB1BD',
        '#B04B74',
        '#8871C8',
        '#F96868',
        '#FBA3BB',
      ],
    };
  },
  computed: {
    listCommentClone() {
      let listCommentCl = _.cloneDeep(this.listComment);
      const userColors = {};
      listCommentCl = listCommentCl.map((item) => {
        if (!userColors[item.userCreated.id]) {
          userColors[item.userCreated.id] = this.listColor[Math.floor(Math.random() * this.listColor.length)];
        }
        // Add the color to the item
        return { ...item, color: userColors[item.userCreated.id] };
      });
      return listCommentCl;
    },
  },
  watch: {
    isOpenTaskCSDK(val) {
      if (!val) {
        this.contentComment = '';
      }
    },
  },
  methods: {
    getTwoLastWordInName(name) {
      // fix case name is empty and name is only one word
      if (!name || name.split(' ').length === 1) return name[0];
      const arrName = name.split(' ');
      return arrName[arrName.length - 2][0] + arrName[arrName.length - 1][0];
    },
    formatDateTime(date) {
      return moment(date).format('HH:mm DD/MM/YYYY');
    },
    sendComment() {
      if (this.contentComment.trim() !== '') {
        this.$emit('sendComment', this.contentComment);
        this.contentComment = '';
      }
    },
    keyMonitor($event) {
      if ($event.keyCode === 13) {
        this.sendComment();
      }
    },
  },
};
</script>

<style lang="scss">
.main-comment-task {
  border-radius: 7px;
  background: #f2f2f2;
  padding: 16px 10px;
  .list-comment {
    max-height: 200px;
    overflow-y: auto;
  }
  .input-chat {
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    background: #fff;
    padding: 10px 8px;
    .form-control {
      border: none;
      width: 100%;
      box-shadow: none;
      &:focus-visible {
        box-shadow: none;
        outline: none !important;
      }
    }
    .btn-send {
      border-radius: 5px;
      background: rgba(92, 91, 220);
      color: #fff;
    }
  }
}
</style>
